import { DeliveryInfoDto } from '.';

export class DeliveryInfo {
    disabledWeekDays: number[];
    logisticMinimumWithoutTax: number;

    constructor(dto: DeliveryInfoDto) {
        this.disabledWeekDays = this.mapDisabledWeekDays(dto);
        this.logisticMinimumWithoutTax = Math.round(100 * (dto.logistic_minimum_lcy ?? 0));
    }

    public isDisabledWeekDay(date: Date): boolean {
        const dayOfWeek = date.getDay();

        return this.disabledWeekDays.includes(dayOfWeek);
    }

    private mapDisabledWeekDays(dto: DeliveryInfoDto): number[] {
        const weekDays: Record<string, boolean> = {
            0: dto.sunday,
            1: dto.monday,
            2: dto.tuesday,
            3: dto.wednesday,
            4: dto.thursday,
            5: dto.friday,
            6: dto.saturday,
        };

        return Object.keys(weekDays)
            .filter((day) => !weekDays[day])
            .map((day) => parseInt(day, 10));
    }
}
